import axios from "axios";

// Fetch states
export const fetchStates = () => async (dispatch) => {
    try {
        dispatch({ type: "GET_CM_YUVA_STATE_PENDING" });
        const response = await axios.get("/api/cm-yuva/state");
        dispatch({
            type: "GET_CM_YUVA_STATE_FULFILLED",
            payload: response.data?.state || [],
        });
    } catch (error) {
        dispatch({
            type: "GET_CM_YUVA_STATE_REJECTED",
            payload: error.response?.data || error.message,
        });
    }
};

// Fetch cities by state ID
export const fetchCities = (stateId) => async (dispatch) => {
    try {
        dispatch({ type: "GET_CM_YUVA_CITY_PENDING" });
        const response = await axios.get(`/api/cm-yuva/city/${stateId}`);
        dispatch({
            type: "GET_CM_YUVA_CITY_FULFILLED",
            payload: response.data?.city || [],
        });
    } catch (error) {
        dispatch({
            type: "GET_CM_YUVA_CITY_REJECTED",
            payload: error.response?.data || error.message,
        });
    }
};